// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"7b7fe06a","286":"48c281d5","530":"1452a8ee","948":"c9d59e83"}[chunkId] + ".chunk.js";
};